// src/services/visionApi.js
// Google Cloud Vision API — 이미지에서 텍스트 추출

const API_KEY = process.env.REACT_APP_GOOGLE_CLOUD_VISION_API_KEY;
// 모듈 로드 시 URL을 확정하지 않음 — extractTextFromImage 호출 시점에 키 유효성 확인 후 생성
const TIMEOUT_MS = 30_000;

function fetchWithTimeout(url, options) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  return fetch(url, { ...options, signal: controller.signal })
    .finally(() => clearTimeout(timer));
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // data:image/png;base64,xxxx → xxxx 부분만 추출
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/**
 * 이미지 파일에서 텍스트를 추출해 반환
 * @param {File} imageFile
 * @returns {Promise<string>} 추출된 텍스트 전문
 */
export async function extractTextFromImage(imageFile) {
  if (!API_KEY) throw new Error('NO_API_KEY');

  const endpoint = `https://vision.googleapis.com/v1/images:annotate?key=${API_KEY}`;
  const base64 = await fileToBase64(imageFile);

  const res = await fetchWithTimeout(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      requests: [{
        image: { content: base64 },
        features: [{ type: 'TEXT_DETECTION', maxResults: 1 }],
        imageContext: { languageHints: ['ko', 'en'] },
      }],
    }),
  });

  if (!res.ok) throw new Error(`VISION_API_ERROR_${res.status}`);

  const json = await res.json();
  const text = json.responses?.[0]?.fullTextAnnotation?.text || '';
  if (!text) throw new Error('NO_TEXT');

  if (process.env.NODE_ENV === 'development') {
    console.log('[Vision OCR] 추출 완료, 길이:', text.length);
  }

  return text;
}
